const initialState = {
  uid: null,
  user: null,
  isLoggedIn: false,
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN':
      return {
        uid: action.payload.uid,
        user: action.payload.user,
        isLoggedIn: true,
      }
    case 'LOGOUT':
      return {
        uid: null,
        user: null,
        isLoggedIn: false,
      }
    default:
      return state
  }
}

export default authReducer
